<script setup lang="ts">
defineProps<{
  title: string;
  content: string;
  tone?: 'info' | 'boundary';
}>();
</script>

<template>
  <aside
    :class="[
      'rounded-2xl border p-6 sm:p-8',
      tone === 'boundary'
        ? 'border-amber-200 bg-amber-50 text-amber-950'
        : 'border-brand-200 bg-brand-50 text-brand-950',
    ]"
  >
    <h2 class="text-xl font-bold">
      {{ title }}
    </h2>
    <p class="mt-3 leading-7">
      {{ content }}
    </p>
  </aside>
</template>
